import { createFileRoute } from '@tanstack/react-router';

type Search = {
  filters?: string;
  ['submit-feedback']?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/call-intelligence')({
  validateSearch: (search: Search): Search => {
    return {
      filters: search.filters,
      ['submit-feedback']: search['submit-feedback'],
    };
  },
});
